import Head from "next/head";

import config from "config";

import { AuthLayout } from "auth";
import Listing from "modules/data-files/views/Listing";

const DataFilesListing = () => {
  return <Listing />;
};

DataFilesListing.getLayout = (page) => (
  <>
    <Head>
      <title>{config.SITE_NAME} | Your Data Files</title>
    </Head>
    {/* We want users to still see their files. */}
    <AuthLayout stopExpiredUsers={false}>{page}</AuthLayout>
  </>
);

export default DataFilesListing;
